const config = {
  pubnubPublishKey: 'pub-c-b8b14417-cff1-4e64-aa43-b41a777352cf',
  pubnubSubscribeKey: 'sub-c-42db9ed2-315c-11e6-9327-02ee2ddab7fe',
  rootUrl: 'https://web.samuraijack.net/',
  // apiBaseUrl: 'https://api.samuraijack.xyz/pixelverse',
  // apiBaseUrl: 'https://api.samuraijack.xyz/v3',
  chatOnlyBaseUrl: 'https://4634b4t26m.execute-api.ap-south-1.amazonaws.com/v1',
  // apiBaseUrl: 'https://insurance-uat.getvisitapp.net/luffy',
  // apiBaseUrl: 'https://api.getvisitapp.net/lazy',
  // apiBaseUrl: 'https://api.getvisitapp.net/stoker',
  // apiBaseUrl: 'https://api.getvisitapp.net/venom',
  apiBaseUrl: 'https://insurance-uat.getvisitapp.net/mercury',

  opdPurchaseUrl: 'https://opd.samuraijack.xyz',
  websiteBaseUrl: 'https://samuraijack.xyz/',
  // pharmaServer: 'https://api.getvisitapp.net/absol',
  // pharmaServer: 'https://retail-stage.getvisitapp.net/retail-ph',
  pharmaServer: 'https://retail-stage.getvisitapp.net/ultron',

  ppmcServer: 'https://ppmc.getvisitapp.net',
  catalystUrl: 'https://catalyst.samuraijack.xyz',
  version: '161',
  v2: '1800009616',
  amplitudeApiKey: '2bfbcb774f5fd6372197d0e43fbda536',
  opentokApiKey: '45467122',
  clevertapId: '585-5KR-KR6Z',
  gpVerticalId: 3,
  oncologistVerticalId: 18,
  ticketingBaseUrl: 'https://help.getvisitapp.net/v4',
  hcpBaseUrl: 'https://api.superslayer.getvisitapp.net/hcp-backend',
  localStorageEncryptionKey: 'visit-pwa@1.1',
  localStorageEncryptionSalt: '87e7c119e0abb08197327867035bd22e',
  pbChatBaseUrl: 'https://4634b4t26m.execute-api.ap-south-1.amazonaws.com/v1',
  hubbleClientId: 'visit-health-4AefioZfPjvOd51A',
  hubbleClientSecret:
    'eI6AZ6Q3mY3ewRx5LeWqdZFa75ygZlM54qpCLaVECeSM5IIAPtZIOwzwTmiJRzZT',
  // Feature flags
  features: {
    enableRefreshToken: false, // Enable automatic token refresh on 401 errors
  },
};
export default config;
